





































































































import CommonBase from "../CommonBase";
import {Component} from "vue-property-decorator";
import rd from "@/modules/vRoutedefs";

@Component
export default class RoleInfo extends CommonBase {
    sectionClass = "pa-2";

  get usersTo() {
    return {name: rd.users.name}
  }
}
